import React, { useEffect } from 'react';
import { Loader } from 'src/@vymo/ui/atoms';
import { Banner } from 'src/@vymo/ui/blocks';
import { clearDetails } from 'src/models/details/slice';
import { useAppDispatch, useAppSelector } from 'src/store/hooks';
import { getIsDialogOpen, getIsLoading, getNotification } from '../selectors';
import ActivityCard from './activityCard';
import ActivityTimelineCard from './activityTimelineCard';
import DoDetails from './entityDetails';
import Header from './header';
import ProfileCard from './profileCard';
import styles from './index.module.scss';

function RevyreDetails({ domainType, workflowType, entityId }) {
  const isLoading = useAppSelector(getIsLoading);
  const isDialogOpen = useAppSelector(getIsDialogOpen);
  const { message, id: messageId, variant } = useAppSelector(getNotification);
  const dispatch = useAppDispatch();

  useEffect(
    () => () => {
      dispatch(clearDetails());
    },
    [dispatch],
  );

  return (
    <Loader visible={isLoading && !isDialogOpen}>
      {message && (
        <Banner
          key={messageId}
          message={message}
          variant={variant}
          position="topRight"
          duration={5000}
          closeable
        />
      )}
      <div className={styles.details}>
        <Header
          domainType={domainType}
          entityId={entityId}
          workflowType={workflowType}
        />
        <div
          className={styles.details__body}
          data-test-id="entity-details-body"
        >
          {domainType !== 'activity' && (
            <div className={styles.details__body__leftSection}>
              <ProfileCard
                domainType={domainType}
                workflowType={workflowType}
                entityId={entityId}
              />
              {localStorage.getItem('enableActivitiesCard') === 'true' && (
                <>
                  <ActivityCard entityId={entityId} cardCode="completed" />
                  <ActivityCard entityId={entityId} cardCode="planned" />
                  <ActivityCard entityId={entityId} cardCode="pending" />
                </>
              )}
            </div>
          )}
          <div className={styles.details__body__rightSection}>
            <DoDetails
              workflowType={workflowType}
              entityId={entityId}
              domainType={domainType}
            />
            <ActivityTimelineCard
              entityId={entityId}
              domainType={domainType}
              workflowType={workflowType}
              type="history"
            />
          </div>
        </div>
      </div>
    </Loader>
  );
}

export default RevyreDetails;
